import {postRequest} from "../util/http";

export const getWebConfig = async () => {
    return await postRequest('zs/dj/getWebConfig')
}
